import { NotFound, ProtectedRoute } from "@fdoh/health-ui-react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import InspectionHomePage from "../InspectionHome/InspectionHome";
import CreateDrainfieldInstallationPage from "./CreateDrainfieldInstallationInspectionForm";
import EditDrainfieldInstallationPage from "./EditDrainfieldInstallationInspectionForm";
import HomePage from "../Home/Home";


export const DrainfieldInstallationInspectionModule = () => {
  let { path } = useRouteMatch();

  return (
    
      <Switch>
          <ProtectedRoute exact path={path}>
              <CreateDrainfieldInstallationPage />
          </ProtectedRoute>
          <ProtectedRoute exact path={`${path}/:id(\\d+)`}>
              <EditDrainfieldInstallationPage />
          </ProtectedRoute>
             
        <Route>
          <NotFound />
        </Route>
      </Switch>
    
  );
};

export default DrainfieldInstallationInspectionModule;
